import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Select,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import makeAnimated from "react-select/animated";
import Pagination from "@mui/material/Pagination";
import EllipsisText from "react-ellipsis-text";
import moment from "moment";
import { EditIcon, ExportIcon } from "@shopify/polaris-icons";
import axios2 from "axios";
import { capitalizeFirstLetter } from "../../Helpers";

const ReportsBookings = () => {
  const navigate = useNavigate();
  const addEditState = useRef("");
  const perPage = 50;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddUser = () => {
    navigate("/admin/settings/users-and-permissions/new");
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[
            { label: "ID", value: "id" },
            { label: "Username", value: "user_name" },
            { label: "Day", value: "day" },
            { label: "Month", value: "month" },
            { label: "Amount", value: "amount" },
          ]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isLoading ? (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  ) : pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : null;

  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };

  const handleClickRow = (param) => {
    //  navigate(`/admin/bookings/${param}`);
    window.open(`/admin/bookings/${param}`, "_blank");
  };
  const [isSaving, setIsSaving] = useState(false);
  const [date, setDate] = useState("");
  const handleChangeDate = (newValue) => {
    setDate(newValue);
  };
  const [month, setMonth] = useState("");
  const handleSelectChangeMonth = (newValue) => {
    setMonth(newValue);
  };
  const handleEdit = (param) => {
    window.open(`/admin/bookings/edit/${param}`, "_blank");
  };

  const [selectedClass, setSelectedClass] = useState("");
  const [optionsClasses, setOptionsClasses] = useState([
    { label: "All", value: "all" },
  ]);
  const [optionsElements, setOptionsElements] = useState([
    { label: "All", value: "all" },
  ]);
  const [selectedElement, setSelectedElement] = useState("");
  const handleSelectChangeClass = (newValue) => {
    setSelectedClass(newValue);
  };
  const [selectedInstructor, setSelectedInstructor] = useState("");
  const [optionsInstructors, setOptionsInstructors] = useState([
    { label: "All", value: "all" },
  ]);
  const handleSelectChangeInstructor = (newValue) => {
    setSelectedInstructor(newValue);
  };
  const handleSelectChangeElement = (newValue) => {
    setSelectedElement(newValue);
  };
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");

  const handleSelectChangePaymentMethod = (newValue) => {
    setSelectedPaymentMethod(newValue);
  };
  const [selectedStudio, setSelectedStudio] = useState("");
  const [optionsStudios, setOptionsStudios] = useState([
    { label: "All", value: "all" },
  ]);
  const handleSelectChangeStudio = (newValue) => {
    setSelectedStudio(newValue);
  };

  const [type, setType] = useState("");
  const handleSelectChangeType = (newValue) => {
    setType(newValue);
  };

  const [selectedSubstudio, setSelectedSubstudio] = useState("");
  const [optionsSubstudios, setOptionsSubstudios] = useState([
    { label: "All", value: "all" },
  ]);
  const handleSelectChangeSubstudio = (newValue) => {
    setSelectedSubstudio(newValue);
  };
  const [selectedDateFrom, setSelectedDateFrom] = useState("");
  const handleChangeDateFrom = (newValue) => {
    setSelectedDateFrom(newValue);
  };
  const [selectedDateTo, setSelectedDateTo] = useState("");
  const handleChangeDateTo = (newValue) => {
    setSelectedDateTo(newValue);
  };
  useEffect(() => {
    axios
      .get(
        `/classes-list${
          selectedElement !== "all"
            ? `?filter[element_id]=${selectedElement}`
            : ""
        }`,
      )
      .then((result) => {
        setOptionsClasses(() =>
          [{ label: "All", value: "all" }].concat([
            ...result.data.data.map((item, index) => {
              return {
                label: item.name,
                value: String(item.id),
              };
            }),
          ]),
        );
      })
      .catch((err) => console.log(err));
  }, [selectedElement]);

  // useEffect(() => {
  //   axios
  //     .get(`/studios/${selectedStudio}/substudios-list`)
  //     .then((result) => {
  //       console.log(result.data.data);
  //       setOptionsSubstudios(() =>
  //         [{ label: "All", value: "all" }].concat([
  //           ...result.data.data.map((item, index) => {
  //             return {
  //               label: item.name,
  //               value: String(item.id),
  //             };
  //           }),
  //         ])
  //       );
  //     })
  //     .catch((err) => console.log(err));
  // }, [selectedStudio]);
  const parseName = (jsonObj) => {
    if (jsonObj?.submembership?.name) {
      return jsonObj.submembership.name;
    } else if (jsonObj?.subpackage?.name) {
      return jsonObj.subpackage.name;
    }
    return null;
  };
  useEffect(() => {
    //console.log("monthhh=", getFirstDayOfMonth(1));
    setPageObject((prev) => ({
      ...prev,
      isLoading: true,
      isListEmpty: false,
      tableItems: [], // ⭐ THIS FIX
      tableTotalPages: 0,
    }));

    fetchData();
  }, [
    ts,
    availability,
    queryValue,
    page,
    date,
    month,
    selectedElement,
    selectedClass,
    selectedInstructor,
    selectedStudio,
    selectedSubstudio,
    selectedDateFrom,
    selectedDateTo,
    selectedPaymentMethod,
    type,
  ]);
  // const getFirstDayOfMonth = (month) => {
  //   const year = new Date().getFullYear();
  //   console.log("year=", year);
  //   const date = new Date(year, month - 1, 1);
  //   const formattedDate = date.toISOString().split("T")[0];
  //   return formattedDate;
  // };
  async function fetchData() {
    let responseReports = "";
    let responseElements = [];
    let responseInstructors = [];
    let responseStudios = [];
    let responseSsubstudios = [];
    try {
      responseReports = await axios.get(
        `/transactions?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }${
          queryValue
            ? `&filter[${
                availability === "" ? "user_name" : availability
              }]=${queryValue}`
            : ""
        }${
          availability !== "" && (date || month)
            ? `&filter_by=${availability[0] === "day" ? "day" : "month"}`
            : ""
        }${date && availability[0] === "day" ? `&date=${date}` : ""}${
          month !== "" && availability[0] === "month"
            ? `&date=${new Date().getFullYear()}-${month}-01`
            : ""
        }${
          selectedElement !== "" && selectedElement !== "all"
            ? `&filter[element_id]=${selectedElement}`
            : ""
        }${
          selectedClass !== "" && selectedClass !== "all"
            ? `&filter[class_id]=${selectedClass}`
            : ""
        }${
          selectedInstructor !== "" && selectedInstructor !== "all"
            ? `&filter[session.instructor.id]=${selectedInstructor}`
            : ""
        }${
          selectedStudio !== "" && selectedStudio !== "all"
            ? `&filter[studio_id]=${selectedStudio}`
            : ""
        }${
          selectedSubstudio !== "" && selectedSubstudio !== "all"
            ? `&filter[sub_studio_id]=${selectedSubstudio}`
            : ""
        }${selectedDateFrom !== "" ? `&from_date=${selectedDateFrom}` : ""}${
          selectedDateTo !== "" ? `&to_date=${selectedDateTo}` : ""
        }${
          selectedPaymentMethod !== "" && selectedPaymentMethod !== "all"
            ? `&filter[payment_type]=${selectedPaymentMethod}`
            : ""
        }${type !== "" && type !== "all" ? `&filter[type]=${type}` : ""}`,
      );

      setPageObject({
        ...pageObject,
        tableItems: responseReports.data.data.data.map((item, index) => [
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item.id}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item.sales_reference}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item.user?.id}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item.user
              ? `${
                  item.user && item.user.first_name
                    ? item.user && item.user.first_name
                    : ""
                } ${
                  item.user && item.user.last_name
                    ? item.user && item.user.last_name
                    : ""
                }`
              : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.user && item.user.email ? item.user.email : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.element && item?.element?.title ? item?.element?.title : "-"}
          </div>,
          // <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
          //   {item?.related_class ? item?.related_class?.name : "-"}
          // </div>,
          // <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
          //   {item?.causer && item.causer.last_name
          //     ? item.causer.last_name
          //     : "-"}
          // </div>,

          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.item_name ? item.item_name : "-"}
          </div>,

          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.session_date
              ? moment(item?.session_date).format("YYYY-MM-DD")
              : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.session_start_time ? item?.session_start_time : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.session_end_time ? item?.session_end_time : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.event_name ? item?.event_name : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {Array.isArray(item?.session_instructors)
              ? item?.session_instructors.join(", ")
              : item?.session_instructors
                ? item?.session_instructors
                : "-"}
          </div>,

          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.session_location ? item.session_location : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item.payment_type ? switchPayment(item.payment_type) : "-"}
          </div>,
          <div className="" onClick={() => handleClickRow(item.id)}>
            {item.type === "Book Course Session"
              ? (item.course?.name ?? "-")
              : (parseName(item) ?? "-")}
          </div>,

          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.amount !== null ? item.amount : "-"}
          </div>,

          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item.card_number ? item.card_number : "-"}
          </div>,

          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.created_at
              ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
              : "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.type ? item.type : "-"}
          </div>,
          <div className="" onClick={() => handleClickRow(item.id)}>
            {item?.status ? (
              <Badge tone={switchStatusColor(item.status)}>
                {capitalizeFirstLetter(item?.status)}
              </Badge>
            ) : (
              "-"
            )}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.user?.loyalty_card_number || "-"}
          </div>,
          <div className="clickableDiv" onClick={() => handleClickRow(item.id)}>
            {item?.user?.loyalty_card_status ? (
              <Badge
                tone={
                  item?.user?.loyalty_card_status === "active"
                    ? "success"
                    : "critical"
                }
              >
                {capitalizeFirstLetter(item?.user?.loyalty_card_status)}
              </Badge>
            ) : (
              "-"
            )}
          </div>,
          <ButtonGroup>
            <Button onClick={() => handleEdit(item.id)} icon={EditIcon}>
              Edit
            </Button>
          </ButtonGroup>,
        ]),
        isLoading: false,
        isListEmpty: !responseReports.data.data.data.length ? true : false,
        tableTotalPages: responseReports.data.data.total,
      });
    } catch (error) {
      console.log(error);
    }

    if (optionsElements.length === 1)
      try {
        responseElements = await axios.get(`/elements?per_page=1000`);
        setOptionsElements((currentObjects) =>
          currentObjects.concat([
            ...responseElements.data.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
              };
            }),
          ]),
        );
      } catch (error) {
        console.log(error);
      }

    if (optionsInstructors.length === 1)
      try {
        responseInstructors = await axios.get(`/instructors-list`);
        setOptionsInstructors((currentObjects) =>
          currentObjects.concat([
            ...responseInstructors.data.data.map((item, index) => {
              return {
                label: item.name,
                value: String(item.id),
              };
            }),
          ]),
        );
      } catch (error) {
        console.log(error);
      }

    if (optionsStudios.length === 1)
      try {
        responseStudios = await axios.get(`/studios-list`);
        setOptionsStudios((currentObjects) =>
          currentObjects.concat([
            ...responseStudios.data.data.map((item, index) => {
              return {
                label: item.name,
                value: String(item.id),
              };
            }),
          ]),
        );
      } catch (error) {
        console.log(error);
      }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "Please check your email to see the exported sheet",
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const refId = useRef(null);
  const [activeVerify, setActiveVerify] = useState(false);
  const handleChangeModalVerify = useCallback((activeVerify) => {
    setActiveVerify(!activeVerify);
    setIsSaving(false);
  }, []);
  const handleYesVerify = () => {
    setIsSaving(true);
    axios
      .post(`/app/users/${refId.current}/verify`)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveVerify(!activeVerify);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const handleExport = () => {
    setIsSaving(true);
    const headers = { Authorization: "Bearer h_YGrV*wAO/EBL1uCh'z!i" };
    axios2
      .get(url, {
        headers,
      })
      .then((result) => {
        setActive(true);
        setIsSaving(false);
      })
      .catch((err) => console.log(err));
  };
  const handleExportSummary = () => {
    setIsSaving(true);
    const headers = { Authorization: "Bearer h_YGrV*wAO/EBL1uCh'z!i" };
    axios2
      .get(
        `${process.env.REACT_APP_BASE_URL}/export/sales-summary-report${
          availability !== "" && (date || month)
            ? `?filter_by=${availability[0] === "day" ? "day" : "month"}`
            : ""
        }${date && availability[0] === "day" ? `&date=${date}` : ""}${
          month !== "" && availability[0] === "month"
            ? `&date=${new Date().getFullYear()}-${month}-01`
            : ""
        }`,
        {
          headers,
        },
      )
      .then((result) => {
        setIsSaving(false);
        window.open(result.data.data, "_blank");
      })
      .catch((err) => console.log(err));
  };
  const switchPayment = (param) => {
    switch (param) {
      case "wallet":
        return `Wallet`;
      case "card":
        return `Card`;
      case "offline_card":
        return `Offline Card`;
      case "cash":
        return `Cash`;
      case "credits":
        return `Credits`;
      case "subscription":
        return `Subscription`;
      case "other":
        return `Other`;
      case "bank_transfer":
        return `Bank Transfer`;
      default:
        return "-";
    }
  };
  const queryParams = [];
  if (queryValue) {
    queryParams.push(
      `filter[${
        availability === "" ? "user_name" : availability
      }]=${queryValue}`,
    );
  }
  if (availability !== "" && (date || month)) {
    queryParams.push(
      `filter_by=${availability[0] === "day" ? "day" : "month"}`,
    );
  }

  if (date && availability[0] === "day") {
    queryParams.push(`date=${date}`);
  }

  if (month && availability[0] === "month") {
    const currentYear = new Date().getFullYear();
    queryParams.push(`date=${currentYear}-${month}-01`);
  }

  if (selectedElement !== "" && selectedElement !== "all") {
    queryParams.push(`filter[element_id]=${selectedElement}`);
  }

  if (selectedClass !== "" && selectedClass !== "all") {
    queryParams.push(`filter[class_id]=${selectedClass}`);
  }

  if (selectedInstructor !== "" && selectedInstructor !== "all") {
    queryParams.push(`filter[session.instructor.id]=${selectedInstructor}`);
  }

  if (selectedStudio !== "" && selectedStudio !== "all") {
    queryParams.push(`filter[studio_id]=${selectedStudio}`);
  }

  if (selectedSubstudio !== "" && selectedSubstudio !== "all") {
    queryParams.push(`filter[sub_studio_id]=${selectedSubstudio}`);
  }

  if (selectedDateFrom !== "") {
    queryParams.push(`from_date=${selectedDateFrom}`);
  }

  if (selectedDateTo !== "") {
    queryParams.push(`to_date=${selectedDateTo}`);
  }

  if (selectedPaymentMethod !== "" && selectedPaymentMethod !== "all") {
    queryParams.push(`filter[payment_type]=${selectedPaymentMethod}`);
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

  const url = `${process.env.REACT_APP_BASE_URL}/export/transactions${queryString}`;
  const switchStatusColor = (param) => {
    switch (param) {
      case "pending":
        return `default`;
      case "confirmed":
        return `success`;
      case "cancelled":
        return `warning`;
      case "cancelled with charge":
        return `warning`;
      case "failed":
        return `critical`;
      default:
        return "";
    }
  };
  return (
    <Page
      title="Bookings"
      primaryAction={
        <ButtonGroup>
          <Button
            variant="primary"
            onClick={handleExportSummary}
            loading={isSaving}
            icon={ExportIcon}
          >
            Export Summary
          </Button>
          <Button
            variant="primary"
            onClick={handleExport}
            loading={isSaving}
            icon={ExportIcon}
          >
            Export Bookings
          </Button>
        </ButtonGroup>
      }
      fullWidth
    >
      <Card padding="0">
        {loadingMarkup}

        {/* <Filters
          queryValue={queryValue}
          queryPlaceholder="Search..."
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        /> */}
        <FormLayout>
          <FormLayout.Group condensed>
            <Select
              label="Filter by element: "
              options={optionsElements}
              onChange={handleSelectChangeElement}
              value={selectedElement}
              labelInline
            />
            <Select
              label="Filter by class: "
              options={optionsClasses}
              onChange={handleSelectChangeClass}
              value={selectedClass}
              labelInline
            />

            <Select
              label="Filter by studio: "
              options={optionsStudios}
              onChange={handleSelectChangeStudio}
              value={selectedStudio}
              labelInline
            />
            <Select
              label="Filter by type: "
              options={[
                { label: "All", value: "all" },
                { label: "Book Session", value: "Book Session" },
                { label: "Book Retreat", value: "Book Retreat" },
                { label: "Package Purchase", value: "Package Purchase" },
                { label: "Membership Purchase", value: "Membership Purchase" },
                { label: "Top Up Wallet", value: "Top Up Wallet" },
                { label: "Book Course Session", value: "Book Course Session" },
                { label: "On Demand Purchase", value: "On Demand Purchase" },
              ]}
              onChange={handleSelectChangeType}
              value={type}
              labelInline
            />
            {/* <Select
              label="Filter by substudio: "
              options={optionsSubstudios}
              onChange={handleSelectChangeSubstudio}
              value={selectedSubstudio}
              labelInline
            /> */}
          </FormLayout.Group>
          <FormLayout.Group>
            <Select
              label="Filter by payment method: "
              options={[
                { label: "All", value: "all" },
                { label: "Wallet", value: "wallet" },
                { label: "Card", value: "card" },
                { label: "Offline Card", value: "offline_card" },
                { label: "Cash", value: "cash" },
                { label: "Credits", value: "credits" },
                { label: "Subscription", value: "subscription" },
                { label: "Bank Transfer", value: "bank_transfer" },
                { label: "Other", value: "other" },
              ]}
              onChange={handleSelectChangePaymentMethod}
              value={selectedPaymentMethod}
              labelInline
            />
            <Select
              label="Filter by session instructor: "
              options={optionsInstructors}
              onChange={handleSelectChangeInstructor}
              value={selectedInstructor}
              labelInline
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <TextField
              prefix="From: "
              value={selectedDateFrom}
              onChange={handleChangeDateFrom}
              labelInline
              type="date"
            />
            <TextField
              prefix="To: "
              value={selectedDateTo}
              onChange={handleChangeDateTo}
              labelInline
              type="date"
            />
          </FormLayout.Group>
          {availability[0] === "day" ? (
            <TextField
              label="Filter by date: "
              value={date}
              onChange={handleChangeDate}
              labelInline
              type="date"
            />
          ) : availability[0] === "month" ? (
            <Select
              label="Filter by month:"
              options={[
                { label: "All", value: "" },
                { label: "January", value: "01" },
                { label: "February", value: "02" },
                { label: "March", value: "03" },
                { label: "April", value: "04" },
                { label: "May", value: "05" },
                { label: "June", value: "06" },
                { label: "July", value: "07" },
                { label: "August", value: "08" },
                { label: "September", value: "09" },
                { label: "October", value: "10" },
                { label: "November", value: "11" },
                { label: "December", value: "12" },
              ]}
              onChange={handleSelectChangeMonth}
              value={month}
            />
          ) : null}
          <Filters
            queryValue={queryValue}
            queryPlaceholder="Search..."
            filters={filters}
            appliedFilters={appliedFilters}
            onQueryChange={handleFiltersQueryChange}
            onQueryClear={handleQueryValueRemove}
            onClearAll={handleFiltersClearAll}
          />
        </FormLayout>

        <DataTable
          columnContentTypes={["text", "text", "text", "text"]}
          headings={[
            <Text variant="bodyMd" as="p" fontWeight="medium">
              ID
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Sale ID
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              User ID
            </Text>,

            <Text variant="bodyMd" as="p" fontWeight="medium">
              Username
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Email
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Element
            </Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Last Name
            // </Text>,

            <Text variant="bodyMd" as="p" fontWeight="medium">
              Class
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Date
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Start Time
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              End Time
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Event
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Instructor(s)
            </Text>,

            <Text variant="bodyMd" as="p" fontWeight="medium">
              Location
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Payment Method
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Package / Membership / Course
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Amount
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Card Number
            </Text>,

            <Text variant="bodyMd" as="p" fontWeight="medium">
              Booking Date
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Type
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Status
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Loyalty Card Number
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Loyalty Card Status
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
          ]}
          rows={pageObject.tableItems}
          verticalAlign="middle"
          increasedTableDensity
          footerContent={
            pageObject.tableItems?.length &&
            `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
          }
          hasZebraStripingOnData
        />
        {emtyState}
        {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              variant="outlined"
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
            />
            {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
          </div>
        )}

        <Modal
          open={activeVerify}
          onClose={handleChangeModalVerify}
          title="Verify User"
          primaryAction={{
            content: "Yes",
            onAction: handleYesVerify,
            loading: isSaving,
          }}
          secondaryActions={[
            {
              content: "No",
              loading: isSaving,
              onAction: handleChangeModalVerify,
            },
          ]}
        >
          <Modal.Section>
            <Text>
              <p>Are you sure you want to verify this user?</p>
            </Text>
          </Modal.Section>
        </Modal>
        {toastMarkup}
      </Card>
    </Page>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
};

export default ReportsBookings;
